export type AppearanceTheme = 'dark' | 'light' | 'system';
export type AppearanceAccent = 'blue' | 'purple' | 'green' | 'orange' | 'pink';
export type AppearanceDensity = 'comfortable' | 'compact';
export type AppearanceMotion = 'full' | 'reduced';

export interface AppearanceSettings {
  theme: AppearanceTheme;
  accent: AppearanceAccent;
  font_size: number;
  density: AppearanceDensity;
  motion: AppearanceMotion;
}

export type AppearanceKey = keyof AppearanceSettings;

export const DEFAULT_APPEARANCE: AppearanceSettings = {
  theme: 'dark', accent: 'blue', font_size: 14,
  density: 'comfortable', motion: 'full',
};

const themes: AppearanceTheme[] = ['dark', 'light', 'system'];
const accents: AppearanceAccent[] = ['blue', 'purple', 'green', 'orange', 'pink'];
const densities: AppearanceDensity[] = ['comfortable', 'compact'];
const motions: AppearanceMotion[] = ['full', 'reduced'];

export const normalizeAppearance = (value: unknown): AppearanceSettings | null => {
  if (!value || typeof value !== 'object') return null;
  const candidate = value as Record<string, unknown>;
  if (
    !themes.includes(candidate.theme as AppearanceTheme)
    || !accents.includes(candidate.accent as AppearanceAccent)
    || !Number.isInteger(candidate.font_size)
    || (candidate.font_size as number) < 13
    || (candidate.font_size as number) > 18
    || !densities.includes(candidate.density as AppearanceDensity)
    || !motions.includes(candidate.motion as AppearanceMotion)
  ) return null;

  return {
    theme: candidate.theme as AppearanceTheme,
    accent: candidate.accent as AppearanceAccent,
    font_size: candidate.font_size as number,
    density: candidate.density as AppearanceDensity,
    motion: candidate.motion as AppearanceMotion,
  };
};
